<div mat-dialog-title class="alert-title">{{ data.message }}</div>
<div mat-dialog-content>
  <p class="alert-message">{{ data.detail }}</p>
</div>
<div mat-dialog-actions class="mat-dialog-actions dialog-actions">
  @for (button of data.buttons; track button; let last = $last) {
    <div class="button" [class.secondary]="!last" (click)="close(button)">{{ button }}</div>
  }
</div>